import { discoveryApiRef, identityApiRef } from "@backstage/core-plugin-api";
import { ApiBlueprint, createApiFactory } from "@backstage/frontend-plugin-api";
import { GitHubClient } from "@internal/backstage-plugin-github-common";
import { githubApiRef } from "@internal/backstage-plugin-github-react";

export const githubApi = ApiBlueprint.make({
    name: "github",
    params: defineParams =>
        defineParams(
            createApiFactory({
                api: githubApiRef,
                deps: {
                    discoveryApi: discoveryApiRef,
                    identityApi: identityApiRef,
                },
                factory: ({ discoveryApi, identityApi }) =>
                    new GitHubClient({ discoveryApi, identityApi }),
            })
        ),
});
